import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  StockCollectionHistoryListContent,
  StockCollectionHistorySearchCriteria
} from '../../model/stock-collection-history.model';

export const StockCollectionHistoryAction = createActionGroup({
  source: 'Stock Collection History',
  events: {
    RequestList: props<{ criteriaObj: StockCollectionHistorySearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<StockCollectionHistoryListContent>;
    }>()
  }
});
